module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_realseereal.d84d2285e8d7801ac9bf52a60f9be34f.png";